import LiveStreaming from "../LiveStreaming";

import { MEDIA_TYPE } from "../enums/LiveStreamingEnums";

export default class Utils {
  static getPeerId(userId, mediaType) {
    const launchId = LiveStreaming.config.launchId;

    if (mediaType == MEDIA_TYPE.WEBCAM) {
      return userId + "|0|" + launchId;
    }
    if (mediaType == MEDIA_TYPE.SCREENSHARE) {
      return userId + "|1|" + launchId;
    }
  }

  static getDataFromPeerId(peerId) {
    let data = peerId.split("|");
    let requestedStreams = {
      webcam: false,
      screen: false
    };

    if (data[1].includes("0")) {
      requestedStreams.webcam = true;
    }

    if (data[1].includes("1")) {
      requestedStreams.screen = true;
    }

    return {
      userId: data[0],
      requestedStreams
    };
  }

  static getMediaType(requestedStreams) {
    if (requestedStreams.webcam) {
      return MEDIA_TYPE.WEBCAM;
    }

    if (requestedStreams.screen) {
      return MEDIA_TYPE.SCREENSHARE;
    }
  }
}
